import { RouteRecordRaw } from 'vue-router'

const templateRoutes: RouteRecordRaw = {
  path: 'home',
  name: 'Home',
  component: () => import('./Home.vue'),
  meta: {
    title: 'Home'
  },
  beforeEnter: async (to, from, next) => {
    next()
  }
}

export default templateRoutes
